// extracted by mini-css-extract-plugin
module.exports = {"legalContainer":"az_zrc","legal":"az_Arc"};